/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AgreementsControllerGetDeliveryStatusEmailConfig$Params {
  id: number;
  delivery_status_id: number;
}

export function agreementsControllerGetDeliveryStatusEmailConfig(http: HttpClient, rootUrl: string, params: AgreementsControllerGetDeliveryStatusEmailConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, agreementsControllerGetDeliveryStatusEmailConfig.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('delivery_status_id', params.delivery_status_id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

agreementsControllerGetDeliveryStatusEmailConfig.PATH = '/agreements/{id}/delivery-status-email-configs/{delivery_status_id}';
